import { COMMON_GET_CUSTOM_FILTERS, COMMON_SET_CUSTOM_FILTERS_LOCAL, COMMON_REPLACE_MODULE_CUSTOM_FILTER } from './constants'
import { BFFAgent } from 'BFFAgent';

export function getCustomFilters(){
  return async (dispatch) => {
    try {
      const customFilters = await BFFAgent.User.getCustomFilters()
      dispatch({type: COMMON_GET_CUSTOM_FILTERS, data: customFilters})
    } catch (error) {
      throw new Error(error)      
    }
  }
}

export function setLocalCustomFilters(filtersData, module, tab){
  return (dispatch) => {
    dispatch({type: COMMON_SET_CUSTOM_FILTERS_LOCAL, data: {filtersData, module, tab}})
  }
}

export function replaceModuleCustomFilter(module, tab, filtersData) {
  return { type: COMMON_REPLACE_MODULE_CUSTOM_FILTER, data: { module, tab, filtersData } }
}

export function reducer(state, action) {
    switch (action.type) {
      case COMMON_GET_CUSTOM_FILTERS:
        return {
          ...state,
          customFilters: action.data
        }
      case COMMON_SET_CUSTOM_FILTERS_LOCAL:{
        let newFilters
        if (!action.data.filtersData){
          newFilters = state.customFilters.filter(customFilter => action.data.tab ? customFilter.tab !== action.data.tab && customFilter.name !== action.data.module : customFilter.name !== action.data.module)
        }
        else{
          newFilters = state.customFilters
          let hasUpdated = false
          for (let filter of newFilters){
            if (action.data.tab ? filter.name == action.data.module && filter.tab == action.data.tab : filter.name == action.data.module){
              filter.filters = action.data.filtersData.filters
              filter.admin_filters = action.data.filtersData.admin_filters
              hasUpdated = true
              break
            }
          }
          if(!hasUpdated){
            let newFilterForModuleAndTab = {
              name: action.data.module,
              tab: action.data.tab,
              filters: action.data.filtersData.filters,
              admin_filters: action.data.filtersData.admin_filters
            }
            newFilters.push(newFilterForModuleAndTab)
          }
        }
        return {
          ...state,
          customFilters: newFilters
        }
      }
      case COMMON_REPLACE_MODULE_CUSTOM_FILTER: {
        const { module, tab, filtersData } = action.data
        const otherFilters = state.customFilters.filter(f =>
          !(f.name === module && (f.tab === tab || !f.tab))
        )
        return {
          ...state,
          customFilters: [...otherFilters, { name: module, tab, ...filtersData }]
        }
      }
      default:
        return state
    }
  }